import { library } from '@fortawesome/fontawesome-svg-core';
import { faHospital, faSquareCheck, faUser } from '@fortawesome/free-regular-svg-icons';
import {
  faCircleArrowDown,
  faDna,
  faListOl,
  faPlus,
  faReceipt,
  fas,
  faVialCircleCheck,
} from '@fortawesome/free-solid-svg-icons';
import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone.js';
import utc from 'dayjs/plugin/utc.js';
import '@myome/ui/styles.css';
import 'react-bootstrap-typeahead/css/Typeahead.bs5.css';
import 'react-bootstrap-typeahead/css/Typeahead.css';

import { ImpersonationBanner } from '@components/ImpersonationBanner/ImpersonationBanner';
import { IS_NATERA } from '@constants/constants';
import { ToastProvider } from '@contexts/useToast';
import { AxiosInterceptor } from '@hooks/useAxios';
import { KeycloakProvider } from '@hooks/useKeycloak';
import RouterProvider from '@router/routesProvider';
import Store from '@store/store';

// Dynamically load theme based on hostname
if (IS_NATERA) {
  import('./App.natera.scss');
} else {
  import('./App.myome.scss');
}

dayjs.extend(utc);
dayjs.extend(timezone);

library.add(
  faUser,
  faHospital,
  faVialCircleCheck,
  faReceipt,
  faPlus,
  faDna,
  faListOl,
  faSquareCheck,
  faCircleArrowDown,
  fas,
);

export const App = () => (
  <div className='d-flex flex-column App'>
    <Store>
      <ToastProvider>
        <KeycloakProvider>
          <ImpersonationBanner />
          <AxiosInterceptor>
            <RouterProvider />
          </AxiosInterceptor>
        </KeycloakProvider>
      </ToastProvider>
    </Store>
  </div>
);
